import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import routerHistory from '../../../routerHistory';
import * as componentActions from '../../../actions/componentActions';
import { bindActionCreators } from 'redux';

import CustomIcon from '../CustomIcon';

import * as messageAlert from '../../../actions/messageAlertAction';

const SIZE = 16;
const ROW_CLASS = 'menu-item-row';
const ROW_SELECTED_CLASS = 'menu-item-row selected';

class MenuItem extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.menuItemClass = ROW_CLASS;
    this.handleClick = this.handleClick.bind(this);
    this.hover = this.hover.bind(this);
    this.endHover = this.endHover.bind(this);
    this.state = {
      isHovered: false
    };
    this.disabledOffline = false;
  }

  static propTypes = {
    icon: PropTypes.string,
    pathname: PropTypes.string,
    title: PropTypes.string,
    to: PropTypes.string,
    id: PropTypes.string,
    disabledOffline: PropTypes.bool,
    messageAlert: PropTypes.any,
    componentActions: PropTypes.any,
    primary: PropTypes.any
  };

  handleClick() {
    const { messageAlert, to, componentActions } = this.props;

    if (to) {
      routerHistory.push(to);
    } else {
      messageAlert.notImplementedYet();
    }

    componentActions.setMenuOpen(false);
  }

  hover() {
    this.setState({
      isHovered: true
    });
  }

  endHover() {
    this.setState({
      isHovered: false
    });
  }

  render() {
    const { icon, pathname, title, to, primary, disabledOffline } = this.props;
    this.menuItemClass = Object.is(to, pathname) ? ROW_SELECTED_CLASS : ROW_CLASS;
    let selectedItemStyle = { backgroundColor: '#fff' };
    let handleClickOff = '';
    {
      if (!disabledOffline) {
        selectedItemStyle =
          (Object.is(to, pathname) || this.state.isHovered) && primary ? { backgroundColor: primary } : {};
        handleClickOff = this.handleClick;
      }
    }

    return (
      <div
        className={!disabledOffline ? this.menuItemClass : 'menu-item-row-offline'}
        onClick={handleClickOff}
        style={selectedItemStyle}
        onMouseOver={this.hover}
        onMouseOut={this.endHover}
      >
        <CustomIcon size={SIZE} name={icon} />
        <div className="menu-item-row-title">{title}</div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItem);

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    connection: state.connection,
    primary: state.theme.colors.primary
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    componentActions: bindActionCreators(componentActions, dispatch)
  };
}
